import React from 'react';

function SetCard (props) {
  return (
    <section className='setCard'>
      <h2 className='ui brown header'>{props.category}</h2>
      <div className='ui items'>
        <div className='item'>
          <div
            className={`ui center aligned ${props.imageSize} image`}
            style={{
              textAlign: 'center !important'
            }}
          >
            <img
              src={props.image}
              style={{
                textAlign: 'center !important',
                margin: '0 auto !important'
              }}
              alt=''
            />
          </div>
          <div className='content'>
            <h3 className='header'>{props.name}</h3>
            <div className='meta'>
              {props.film &&
                <i
                  className='icon film'
                  style={{
                    marginRight: '5px'
                  }}
                >
                </i>
              }
              {props.film}
              </div>
            <div className='description'>
              {props.children}
            </div>
            {props.trailer &&
              <div
                style={{
                  marginTop: '-15px'
                }}
              >
                <br/>
                  <a
                  className="ui label"
                  href={props.trailer ? props.trailer : ''}
                  target='_blank'
                >
                  <i className='play icon'></i>
                  Trailer
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    </section>
  )
}

SetCard.propTypes = {
  category: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  film: React.PropTypes.string,
  image: React.PropTypes.string.isRequired,
  imageSize: React.PropTypes.string,
  children: React.PropTypes.element.isRequired,
  trailer: React.PropTypes.string
};

SetCard.defaultProps = {
  imageSize: 'small'
};

export default SetCard;



// WEBPACK FOOTER //
// ./src/components/main/setCard/index.js